
export default {
    GetFaq: (data) => window.axios.get(`faq/listing?type=${data.type}`, data)
}